export default __webpack_public_path__ + "static/default-broker-image-236de7f4c5872ae069b1279d71b0affd.png";